import { render, staticRenderFns } from "./Liabilities.vue?vue&type=template&id=2eee0b8c&scoped=true"
import script from "./Liabilities.vue?vue&type=script&lang=js"
export * from "./Liabilities.vue?vue&type=script&lang=js"
import style0 from "./Liabilities.vue?vue&type=style&index=0&id=2eee0b8c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eee0b8c",
  null
  
)

/* custom blocks */
import block0 from "./Liabilities.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports